// src/components/common/AnimatedText.js

import React from 'react';
import { motion } from 'framer-motion';
import styled from '@emotion/styled';

const TextWrapper = styled(motion.div)`
  display: inline-block;
  overflow: hidden;
`;

const Text = styled(motion.span)`
  display: inline-block;
  white-space: pre;
`;

const AnimatedText = ({ text, delay = 0, duration = 0.05, ...props }) => {
  const letters = Array.from(text);
  
  const container = {
    hidden: { opacity: 0 },
    visible: (i = 1) => ({
      opacity: 1,
      transition: { staggerChildren: duration, delayChildren: delay * i }
    })
  };
  
  const child = {
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        damping: 12,
        stiffness: 100
      }
    },
    hidden: {
      opacity: 0,
      y: 20,
      transition: {
        type: 'spring',
        damping: 12,
        stiffness: 100
      }
    }
  };
  
  return (
    <TextWrapper
      variants={container}
      initial="hidden"
      animate="visible"
      {...props}
    >
      {letters.map((letter, index) => (
        <Text variants={child} key={index}>
          {letter === ' ' ? '\u00A0' : letter}
        </Text>
      ))}
    </TextWrapper>
  );
};

export default AnimatedText;